/*eslint-disable*/
import React from "react";
import './footer.scss'

import Logo from '../../../assets/img/revamp/vibernets/Vibernets Academy grey.png';
import {Link, NavLink} from "react-router-dom";
import webConfig from "../../../config/WebConfig";
import * as constants from '../../../const/constants';
import YOUTUBE from "../../../assets/img/revamp/vibernets/icons8-youtube-48.png";
import FB from "../../../assets/img/revamp/vibernets/icons8-facebook-48.png";
import WHATSAPP from "../../../assets/img/revamp/vibernets/icons8-whatsapp-48.png";
import LINKEDIN from "../../../assets/img/revamp/vibernets/icons8-linkedin-48.png";
import * as actionCreator from "../../../store/domain/classes/action";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionModalCreator from "../../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";


class CardsFooter extends React.Component {

    reRouteWithId = (place) => {
        window.location.href = constants.BASE_ROUTE + place
    };

    render() {
        return (
            <React.Fragment>
                <footer className="footer-area pb-5 ptb-100">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-md-4">
                                <div className="single-footer">
                                    <h4 className="logo">
                                        <a href="#home">
                                            <img style={{maxWidth: "40%"}} src={Logo} alt="log"/>
                                        </a>
                                    </h4>
                                    <p>{webConfig.FooterDesc}</p>

                                    {/*<div style={{textAlign: 'start'}}>*/}
                                    {/*<h6 style={{*/}
                                    {/*    color: 'black',*/}
                                    {/*    padding: 0,*/}
                                    {/*    paddingBottom: 5,*/}
                                    {/*    margin: 0,*/}
                                    {/*    fontWeight: 600,*/}
                                    {/*    fontSize: 18*/}
                                    {/*}}>Follow Us</h6>*/}
                                    {/*<div style={{display: 'flex', flexDirection: 'row', gap: 20}}>*/}
                                    {/*    <a target={"_blank"} href={"https://www.youtube.com/c/VibernetsStreaming"}>*/}
                                    {/*        <img alt={"YOUTUBE"} className={"why-us-contact-img"}*/}
                                    {/*             src={YOUTUBE}/></a>*/}
                                    {/*    <a href={"https://www.facebook.com/vibernets"} target={"_blank"}>*/}
                                    {/*        <img alt={"FB"} className={"why-us-contact-img"} src={FB}/></a>*/}
                                    {/*    <a target={"_blank"} href={"https://wa.me/94702171111"}>*/}
                                    {/*        <img alt={"WHATSAPP"} className={"why-us-contact-img"} src={WHATSAPP}/></a>*/}
                                    {/*    <a target={"_blank"}*/}
                                    {/*       href={"https://www.linkedin.com/company/vibernetsacademy/"}>*/}
                                    {/*        <img alt={"LINKEDIN"} className={"why-us-contact-img"} src={LINKEDIN}/></a>*/}
                                    {/*</div>*/}
                                    {/*</div>*/}

                                    <div className=' social-media d-flex justify-content-start pt-2' style={{gap: 5}}>
                                        <a target={"_blank"} href={"https://www.youtube.com/c/VibernetsStreaming"}>
                                            <img alt={"YOUTUBE"} className={"why-us-contact-img"}
                                                 src={YOUTUBE}/></a>
                                        <a href={"https://www.facebook.com/vibernets"} target={"_blank"}>
                                            <img alt={"FB"} className={"why-us-contact-img"} src={FB}/></a>
                                        <a target={"_blank"} href={"https://wa.me/94702171111"}>
                                            <img alt={"WHATSAPP"} className={"why-us-contact-img"} src={WHATSAPP}/></a>
                                        <a target={"_blank"}
                                           href={"https://www.linkedin.com/company/vibernetsacademy/"}>
                                            <img alt={"LINKEDIN"} className={"why-us-contact-img"} src={LINKEDIN}/></a>
                                        {/*<a href={'https://web.facebook.com/edulabinstitute/?_rdc=1&_rdr'}>*/}
                                        {/*    <Icon style={{color: `${webConfig.secondaryColor}`}} className='mr-4'*/}
                                        {/*          color='#ADAFBF' height='30px' icon="bxl:facebook"/>*/}
                                        {/*</a>*/}
                                        {/*<a href={'https://youtu.be/e6WjY2wjLbM'}>*/}
                                        {/*    <Icon style={{color: `${webConfig.secondaryColor}`}} className='mr-4'*/}
                                        {/*          color='#ADAFBF' height='30px'*/}
                                        {/*          icon="akar-icons:youtube-fill"/>*/}
                                        {/*</a>*/}
                                        {/*<a href={'https://api.whatsapp.com/send?phone=94769699288'}>*/}
                                        {/*    <Icon style={{color: `${webConfig.secondaryColor}`}} className='mr-4'*/}
                                        {/*          color='#ADAFBF' height='30px'*/}
                                        {/*          icon="akar-icons:whatsapp-fill"/>*/}
                                        {/*</a>*/}

                                    </div>

                                    <p className="mt-6">
                                        © {new Date().getFullYear()} All rights reserved | Powered by Edulab
                                    </p>

                                </div>
                            </div>
                            <div className="col-lg-2 col-md-2"></div>
                            <div className="col-lg-2 col-md-2">
                                <div className="single-footer footer-navbar-nav">
                                    <h3>Services</h3>
                                    <div className='d-flex flex-column'>


                                        <Link
                                            className="py-2" style={{color: '#ADAFBF'}}
                                            // to= {`${constants.HOME_COURSE_ROUTE}`}
                                            // className={`nav-event-btn`}
                                            onClick={() =>
                                                this.props.history.push({
                                                    pathname: `${constants.HOME_COURSE_ROUTE}`,
                                                    state: this.props.userType
                                                })
                                                // routeHandler()
                                            }
                                            // onClick={() => this.reRouteWithId('#teachersSection')}
                                        >
                                            Courses
                                        </Link>


                                        {/* <li>
                                            {this.props.pageName === "home" ? (
                                                <a href="#pricing">
                                                    <i className="icofont-double-right" />
                                                    Pricing
                                                </a>
                                            ) : (
                                                <NavLink
                                                    to="/"
                                                    activeClassName=""
                                                >
                                                    <i className="icofont-double-right" />
                                                    pricing
                                                </NavLink>
                                            )}
                                        </li> */}

                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-2 col-md-2">
                                <div className="single-footer">
                                    <h3>Institute</h3>
                                    <div className='d-flex flex-column'>
                                        {/*<NavLink*/}
                                        {/*    className="py-2" style={{color: '#ADAFBF'}}*/}
                                        {/*    to="/"*/}
                                        {/*    activeClassName="">*/}
                                        {/*    Address*/}
                                        {/*</NavLink>*/}

                                        <a
                                            className={"py-2"}
                                            style={{textDecoration: 'none', color: '#ADAFBF'}}
                                            href={"#"} target={"_blank"}>
                                            Phone <span style={{color: 'rgba(17, 29, 42, 0.85)', paddingLeft: 2}}>+94 702 171 111</span>
                                        </a>

                                        <a
                                            className={"py-2"}
                                            style={{textDecoration: 'none', color: '#ADAFBF'}}
                                            href={"#"} target={"_blank"}>
                                            Email <span style={{
                                            color: 'rgba(17, 29, 42, 0.85)',
                                            paddingLeft: 2
                                        }}>info@vibernets.com</span>
                                        </a>

                                        {/*<NavLink*/}
                                        {/*    className="py-2" style={{color: '#ADAFBF'}}*/}
                                        {/*    to="/"*/}
                                        {/*    activeClassName="">*/}
                                        {/*    Phone*/}
                                        {/*</NavLink>*/}

                                        {/*<NavLink*/}
                                        {/*    className="py-2" style={{color: '#ADAFBF'}}*/}
                                        {/*    to="/"*/}
                                        {/*    activeClassName="">*/}
                                        {/*    Email*/}
                                        {/*</NavLink>*/}
                                    </div>
                                </div>
                            </div>


                            <div className="col-lg-2 col-md-2">
                                <div className="single-footer">
                                    {/*<h3>Help</h3>*/}
                                    <div className='d-flex flex-column footer-items-center'>
                                        <a
                                            className={`nav-event-btn`}
                                            // onClick={() => this.routeHandler(constants.HOME_HELP_ROUTE)}
                                            href={constants.BASE_ROUTE + constants.HOME_HELP_ROUTE}
                                        >
                                            Help
                                        </a>
                                        <NavLink
                                            className="py-2" style={{color: '#ADAFBF'}}
                                            to='#FAQ'
                                            className={`nav-event-btn`}
                                            onClick={() => this.reRouteWithId('#FAQ')}
                                        >
                                            FAQ
                                        </NavLink>
                                        <NavLink
                                            className="py-2" style={{color: '#ADAFBF'}}
                                            to='#inquiryForm'
                                            className={`nav-event-btn`}
                                            onClick={() => this.reRouteWithId('#inquiryForm')}
                                        >
                                            Contact Us
                                        </NavLink>

                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>

                </footer>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    userType: state.auth.userType,
    lecturer: state.lecturer.lecturer,
    userObj: state.student.userObj
});

const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CardsFooter));

// export default CardsFooter;
